import { Clickable, Image, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, media } = theme;

export const Title = styled(P)`
  font-size: 1.25rem;
`;

export const CtaWrapper = styled.div`
  min-height: 2rem;
`;

export const DescriptionWrapper = styled.div`
  min-height: 5rem;
`;

export const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  width: 35%;
`;

export const StyledImage = styled(Image)`
  max-height: 100%;
`;

export const InformationWrapper = styled.div`
  width: 65%;
`;

export const StyledClickable = styled(Clickable)`
  color: ${colors.purple};
  font-weight: bold;
`;

export const TileWrapper = styled.div`
  border: 1px solid ${colors.grey20};
  display: flex;
  gap: 1rem;
  padding: 2rem 1.5rem;

  @media (min-width: ${media.md}) {
    max-height: 14rem;
  }
`;
